/**
 * Locator results message — Shape 2 "where does it talk about..." answers.
 *
 * One template sentence per verified result, no commentary. The reference
 * chip is clickable and drops the reader into the passage (Shape 1 handoff).
 */

import type { LocatorResult, BibleLocation } from '@skjv/common';
import { bibleState } from '@/state/bible-state';

interface LocatorResultsMessageProps {
  query: string;
  entityName: string | null;
  results: LocatorResult[];
}

function toLocation(result: LocatorResult): BibleLocation {
  return {
    testamentIndex: result.testament - 1,
    bookIndex: result.bookNumber - 1,
    chapterIndex: result.chapterNumber - 1,
    verseIndex: result.verseNumber - 1,
  };
}

export function LocatorResultsMessage({ query, entityName, results }: LocatorResultsMessageProps) {
  return (
    <div className="locator-results-message" data-testid="locator-results">
      <div className="search-results-header">
        {entityName
          ? <>The Bible speaks of <strong>{entityName}</strong> here:</>
          : <>Here is where the Bible speaks about <em>"{query}"</em>:</>}
      </div>

      <div className="locator-results-list">
        {results.map((result, i) => (
          <div key={i} className="locator-result-item" data-testid="locator-result">
            <button
              className="search-result-ref locator-result-ref"
              onClick={() => bibleState.setCurrentLocation(toLocation(result))}
              title={`Open ${result.reference}`}
            >
              {result.reference}
            </button>
            <p className="locator-result-sentence">{result.sentence}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
